import { all, call, put, takeLatest } from "redux-saga/effects";
// import { call } from "redux-saga/effects";
import { authActions } from "../slices/authSlice";
import authService from "../../services/authService";
// import authService from "../../services/authService";

function* loginSaga({ payload }) {
  try {
    const data = yield call(authService.login, {
      email: payload.email,
      password: payload.password,
    });
    yield put(authActions.loginSuccess(data));

    payload.handleLoginSuccess(data);
  } catch (e) {
    payload.handleLoginError(e.response.data);

    yield put(authActions.loginError(e.response.data));
  }
}

export default function* authSaga() {
  yield all([takeLatest("auth/loginFetch", loginSaga)]);
}
